"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _ModalFrame = _interopRequireDefault(require("./ModalFrame"));

var _ScrollLock = _interopRequireDefault(require("ui-addon-upgrades/ScrollLock"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _Fragment = _interopRequireDefault(require("../Fragment"));

var UpgradeModal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UpgradeModal, _React$Component);

  function UpgradeModal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UpgradeModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UpgradeModal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      loadModal: false,
      showModal: false,
      modalReady: false
    };

    _this.handleMouseOver = function () {
      _this.setState({
        loadModal: true
      });
    };

    _this.handleClick = function () {
      _this.setState({
        showModal: true,
        loadModal: true
      });

      tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
        action: 'clicked'
      }, _this.getUpgradeData()));
    };

    _this.getUpgradeData = function () {
      var upgradeData = _this.props.upgradeData;
      var app = upgradeData.app,
          screen = upgradeData.screen,
          uniqueId = upgradeData.uniqueId;
      return (0, _extends2.default)({}, upgradeData, {
        source: app + "-" + screen + "-locked-feature-" + uniqueId
      });
    };

    return _this;
  }

  (0, _createClass2.default)(UpgradeModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      tracker.track('lockedFeatureInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, this.getUpgradeData()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          loadModal = _this$state.loadModal,
          showModal = _this$state.showModal,
          modalReady = _this$state.modalReady;
      var _this$props = this.props,
          children = _this$props.children,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
      var upgradeData = this.getUpgradeData();
      var currentQueryParamString = window.location.search.substring(1);
      return _react.default.createElement(_Fragment.default, null, children({
        handleClick: this.handleClick,
        handleMouseOver: this.handleMouseOver,
        openUpgradeModal: this.handleClick,
        preloadUpgradeModal: this.handleMouseOver
      }), loadModal && _react.default.createElement(_ModalFrame.default, {
        id: "ui-addon-upgrade-modal-frame",
        src: "/upgrade-modal/" + _hubspot.default.get() + "?domain=" + document.domain + "&" + currentQueryParamString,
        setShowModal: function setShowModal(value) {
          return _this2.setState({
            showModal: value
          });
        },
        setLoadModal: function setLoadModal(value) {
          return _this2.setState({
            loadModal: value
          });
        },
        setModalReady: function setModalReady(value) {
          return _this2.setState({
            modalReady: value
          });
        },
        showModal: showModal,
        modalReady: modalReady,
        frameProps: (0, _extends2.default)({}, rest, {
          upgradeData: upgradeData,
          domain: document.domain,
          showModal: showModal
        })
      }), modalReady && showModal && _react.default.createElement(_ScrollLock.default, null));
    }
  }]);
  return UpgradeModal;
}(_react.default.Component);

UpgradeModal.propTypes = {
  upgradeData: _react.PropTypes.object.isRequired,
  modalKey: _react.PropTypes.string.isRequired,
  children: _react.PropTypes.func.isRequired
};
var _default = UpgradeModal;
exports.default = _default;
module.exports = exports.default;